import React from 'react';
import { Intl, useQuery } from '@erecruit/core';
import { useHistory } from 'react-router-dom';
import {
  CardOverview,
  styled,
  H1,
  H2,
  FrameLayout,
  Container,
  PageMenu,
  PageMenuItem,
} from '@erecruit/ui-kit';
import {
  useFilterByPermissions,
  Authorize,
  PageUnauthorized,
} from '@erecruit/modules';
import { settingsMap, SettingsKey } from './settingsMap';

const { FormattedMessage } = Intl;

const SettingsTitle = styled(H1)({ margin: 0, paddingLeft: 20 });

const items: (PageMenuItem & { permission?: string })[] = Object.keys(
  settingsMap,
).map(key => {
  const item = settingsMap[key as SettingsKey];
  return {
    icon: item.icon,
    text: <FormattedMessage id={item.title} />,
    key,
    permission: item.permission,
  };
});

const MenuContainer = styled(Container)({
  width: 270,
});

export const Settings: React.FunctionComponent<{}> = () => {
  const history = useHistory();

  const authorizedPageMenuItems = useFilterByPermissions(items);

  const query = useQuery<{ section: SettingsKey }>();
  const item = settingsMap[query.section];

  if (!query.section) {
    history.push(settingsMap['profile'].route);
    return <></>;
  }

  return (
    <Container padding={[9, 10, 10, 4]} stretch>
      <FrameLayout
        columnsGutter={40}
        rowsGutter={25}
        header={<SettingsTitle>Settings</SettingsTitle>}
        content={
          <Authorize permission={item.permission}>
            {(isAuthorized: boolean) =>
              isAuthorized ? (
                <CardOverview
                  title={
                    <H2 color="headerPrimary">
                      <FormattedMessage id={item.title} />
                    </H2>
                  }
                  extraComponent={null}
                  stretch
                  overflow
                >
                  {item.content}
                </CardOverview>
              ) : (
                <PageUnauthorized />
              )
            }
          </Authorize>
        }
        menu={
          <MenuContainer>
            <PageMenu
              onSelect={item =>
                history.push(settingsMap[item.key as SettingsKey].route)
              }
              selectedKey={query.section}
              items={authorizedPageMenuItems}
            />
          </MenuContainer>
        }
      />
    </Container>
  );
};
